import { Controller } from "@hotwired/stimulus"
import Shepherd from 'shepherd.js';

// Connects to data-controller="tour"
export default class extends Controller {
  static values = {
    stepsPath: String,
  }

  connect() {
    this.tour = new Shepherd.Tour({
      useModalOverlay: true,
      steps: this.stepsValue
    });
  }

  nextStep() {
    this.tour.next()
  }

  previousStep() {
    this.tour.back()
  }

  stop() {
    this.tour.cancel()
  }

  start(e) {
    e.preventDefault()

    // if the user is re-launching the tour, don't refetch the steps
    if (this.tour.steps.length > 0) {
      this.tour.start()
      return
    }

    fetch(this.stepsPathValue).then(response => {
      response.json().then(steps => {

        steps.forEach(step => {
          // Some steps are two-in-one. We sometimes want to attach to an element
          // that first requires a page visit, but we still want to higlight the
          // element we had to reference to get there. In this case, we add a `visitElement` property
          // which we can use to trigger the turbo visit before showing the step, and then we maintain
          // a reference to it by adding it to the `extraHighlights` property.
          if (step.visitElement) {
            let existingExtraHighlights = step.extraHighlights || []
            step.extraHighlights = [...existingExtraHighlights,step.visitElement]

            step.beforeShowPromise = function() {
              let element = document.querySelector(step.visitElement)
              Turbo.visit(element.dataset.tourUrl || element.href, { frame: "map_overlay" })

              return new Promise(function(resolve) {
                document.addEventListener('turbo:frame-render', () => {
                  // wait for the frame to render before attaching to the element
                  resolve()
                })
              })
            }
          }

          this.tour.addStep(step)
        })
        this.tour.start()
      })
    })
  }
}